export const shouldShowLive = (catalogStatus: string, isCatalogOnly: boolean, saleStartTs: number) => {
    const secondsUntilStart = saleStartTs - Date.now() / 1000;
    return (
        !isCatalogOnly &&
        (catalogStatus === 'live' ||
            catalogStatus === 'paused' ||
            (catalogStatus === 'online' && secondsUntilStart < 60 * 10))
    );
};
